/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {FONTS} from "@res/fonts";
import * as React from "react";
import * as emotion from "emotion";
import {COLORS} from "@res/colors";
import {
	PADDING_LEFT,
	PADDING_RIGHT
} from "./AppDialog";

type Props = {
	title: string
}

const header = emotion.css(
	{
		paddingLeft: PADDING_LEFT,
		paddingRight: PADDING_RIGHT,
		paddingTop: 26,
		paddingBottom: 14,
		borderBottom: `1px solid ${COLORS.neutral_gray_2}`
	}
);

export class DialogTitle
	extends React.Component<Props> {

	render() {
		return <div className={`ll_h_c ${header}`}>
			<div>
				{
					FONTS.medium_18_blue(this.props.title)
				}
			</div>
		</div>;
	}

}